import React from 'react';
import { Award, Brain, Target } from 'lucide-react';

export default function About() {
  const highlights = [
    {
      icon: <Brain className="w-5 h-5 text-zinc-100" />,
      title: "Strategic Thinker",
      desc: "Architecting cloud solutions that bridge technical capabilities with business goals."
    },
    {
      icon: <Target className="w-5 h-5 text-zinc-100" />,
      title: "Problem Solver",
      desc: "Tackling complex scalable challenges across multi-cloud environments."
    },
    {
      icon: <Award className="w-5 h-5 text-zinc-100" />,
      title: "Continuous Learner",
      desc: "Always exploring the bleeding edge of containerization and orchestration."
    }
  ];

  return (
    <section id="about" className="scroll-mt-24 space-y-12">
      <div className="lg:hidden text-sm font-bold uppercase tracking-widest text-zinc-200 mb-8 sticky top-0 z-10 w-full bg-zinc-950/90 backdrop-blur pb-4 pt-10">
        About
      </div>

      <div className="space-y-6 text-zinc-400 leading-relaxed">
        <p>
          It started with a Docker assignment during an overseas internship in 2023. Two years later, I'm architecting cloud-native systems, untangling legacy monoliths into microservices, and building CI/CD pipelines that actually make developers' lives easier.
        </p>
        <p>
          My focus is on building scalable, highly available infrastructure across GCP, AWS, and Azure—with a particular love for the overlap between Infrastructure as Code and Site Reliability Engineering. There's something satisfying about writing Terraform that just works, and knowing the system underneath is solid enough to sleep soundly at night.
        </p>
        <p>
          When I'm not in the weeds of deployment manifests or cloud configs, I'm usually keeping tabs on where AI and infrastructure tooling are headed next—or spinning up something new with whatever free credits I can get my hands on.
        </p>
      </div>

      <div className="grid sm:grid-cols-3 gap-6 pt-6">
        {highlights.map((item, index) => (
          <div key={index} className="flex flex-col gap-3 group">
            <div className="w-10 h-10 rounded border border-zinc-800 bg-zinc-900/50 flex items-center justify-center group-hover:bg-zinc-800 transition-colors">
              {item.icon}
            </div>
            <div>
              <h4 className="font-medium text-zinc-100 mb-1">{item.title}</h4>
              <p className="text-sm text-zinc-500 leading-relaxed">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}